var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.validationOutput.error)?_c('span',{staticClass:"text-sm",class:{ 'text-warning': _vm.validationOutput.error }},[_vm._v("\n  "+_vm._s(_vm.validationOutput.message)+"\n  "),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }